import { render } from "./pay-order.vue?vue&type=template&id=74f226e3&scoped=true"
import script from "./pay-order.vue?vue&type=script&lang=js"
export * from "./pay-order.vue?vue&type=script&lang=js"

import "./pay-order.vue?vue&type=style&index=0&id=74f226e3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f226e3"]])

export default __exports__